// <Icon type="audio" />
import React from 'react';
import { AudioPlayer } from 'common/components/AudioPlayer';
interface ModelProps {
  model: any;
}

export default (props: ModelProps) => {
  const { model } = props;
  return (
    <AudioPlayer
      type="detail"
      fileType={model.resourceFormat}
      src={model.resourceUrl}
    />
  );
};
